import React from 'react'
import {AccordionContent} from 'hec/components/ui/accordion'
import {useAccordionContext} from './accordionContext'

interface CustomAccordionDetailProps {
    className?: string
    renderContent?: () => React.ReactNode
}

export const CustomAccordionDetail: React.FC<CustomAccordionDetailProps> = ({
    className,
    renderContent,
    ...props
}) => {
    const {shouldExpandDetails, itemIndex} = useAccordionContext()

    return (
        <AccordionContent
            className={className}
            data-testid="accordionDetail-AccordionContent"
            {...props}
        >
            {shouldExpandDetails(itemIndex) && renderContent?.()}
        </AccordionContent>
    )
}
